import React from 'react';
import { Link, useNavigate as useHistory } from "react-router-dom";
import Header from './Header';
import Footer from './Footer';
import FlashMessage from '../FlashMessage/Index';
import HttpRequest from '../../../Libraries/HttpRequest/HttpRequest';
import { Context } from "../../../Store/Store";
import Helper from '../../../Helper';
import api from '../../../Api';

function Login() {
    // const [state,dispatch] = React.useContext(Context);

    let history = useHistory();

    // const removeFlashMessage = () => {
    //   dispatch({
    //     type: "SET_STATE",
    //     response: [],
    //     flash_message_show: false,
    //   });
    // }

    // const showFlashMessage = (data) => {
    //     dispatch({
    //       type: "SET_STATE",
    //       response: data,
    //       flash_message_show: true,
    //   });
    // }

    const autentication = async (event) => {
        event.preventDefault();
        console.log('event--->', event)
        //   removeFlashMessage()
        let form = event.target;
        let params = new FormData(form);
        let admin_route = api.admin_login;
        let response = await HttpRequest.makeRequest(admin_route.method, admin_route.url, params)
        if (response.data.code != 200) {
            console.log(response)
            // showFlashMessage(response);
        } else {
            Helper.setStorageData('session', response.data.data);
            history("/")
        }
    }

    return (
        <div className='login-container'>
            <div className='w-75 d-flex flex-column justify-content-center align-items-center'>
                <Header />
                <div className="misc-box bg-white w-50 p-5 rounded">
                    <FlashMessage />
                    <form onSubmit={autentication}>
                        <div className="form-group">
                            <label htmlFor="exampleuser1">Email</label>
                            <div className="group-icon">
                                <input id="exampleuser1" type="email" name="email" placeholder="Email" className="form-control" required="" />
                                <span className="icon-user text-muted icon-input"></span>
                            </div>
                        </div>
                        <div className="form-group">
                            <label htmlFor="exampleInputPassword1">Password</label>
                            <div className="group-icon">
                                <input id="exampleInputPassword1" type="password" name="password" placeholder="Password" className="form-control" />
                                <span className="icon-lock text-muted icon-input"></span>
                            </div>
                        </div>
                        <div className="clearfix">
                            <div className="float-right">
                                <button className="btn btn-block cs-bg-dark text-white btn-rounded box-shadow">Login</button>
                            </div>
                        </div>
                    </form>
                </div>
                <Footer />
            </div>
        </div>
    );
}
export default Login
